import React, { useState, useEffect } from "react";
import icon from '../../assets/quotes.svg';
import axios from "axios";
import { GrNext } from "react-icons/gr";

const ClientReviews = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews?.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? reviews?.length - 1 : prevIndex - 1
        );
    };

    useEffect(() => {
        console.log(currentIndex)
    }, [currentIndex])

    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getreviews`);
                setReviews(response.data);
            } catch (error) {
                console.error('Error fetching FAQs:', error);
            }
        };

        fetchReviews();
    }, []);


    return (
        <div className="relative w-full bigscreen p-16 mt-20">

            <div className='font-semibold text-[28px] text-center mb-8'>
                Hear from our clients!
            </div>

            {/* Carousel Container */}
            <div className="overflow-hidden">
                <div
                    className="flex transition-transform duration-500 ease-in-out"
                    style={{ transform: `translateX(-${currentIndex * 100 / 3}%)` }}
                >
                    {reviews?.length > 0 && reviews?.map((testimonial) => (

                        <div key={testimonial._id} className="w-full md:w-1/3 flex-shrink-0 p-4">
                            <div className="bg-white shadow-md rounded-xl p-8">
                                <img
                                    src={icon}
                                    alt='icon'
                                    className="w-14 h-14 mr-auto object-contain mb-4"
                                />
                                <div className='text-xs flex gap-3 font-light text-[rgba(0, 0, 0, 0.59)]'>
                                    {testimonial?.review}
                                </div>

                                <div className='border-b mt-6'
                                    style={{ borderColor: "rgba(0, 0, 0, 0.22)" }}
                                ></div>

                                <h3 className="mt-4 font-semibold text-xs">{testimonial?.name}</h3>
                                <p className="text-xs flex gap-3 font-light text-[rgba(0, 0, 0, 0.59)]">
                                    {testimonial?.designation}
                                    {testimonial?.company && `, ${testimonial.company}`}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Navigation Buttons */}
            <button
                onClick={prevSlide}
                className="absolute left-10 top-1/2 transform translate-y-[70%] rotate-180"
            >
                <GrNext />
            </button>
            <button
                onClick={nextSlide}
                className="absolute right-10 top-1/2 transform translate-y-[70%]"
            >
                <GrNext />
            </button>
        </div>
    );
};

export default ClientReviews;